import { extractData } from "../../../../utils";
import { API_URL } from "../../../../utils/constant";
import { APIError, handleAPIError } from "../../../common/errorHandler";
import { getDecoratedUrl } from "../../../common/urlService";
import { getApiAsyn, baseUrl, getAuthHeaders } from "../../../PostAPI";
import axios from "axios";

export const fetchUser = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.SYSTEM_USERS.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result || [];
    // return extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchUsersById = async (payload) => {
  const url = API_URL.SYSTEM_USERS.GET_BY_ID.replace(":id", payload?.id);
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };

  if (isEdit) {
    return axios.put(baseUrl + url, data, config);
  } else {
    return axios.post(baseUrl + url, data, config);
  }
};

export const updateUser = async (payload) => {
  const url = API_URL.SYSTEM_USERS.EDIT.replace(":id", payload?.id);

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const createUser = async (payload) => {
  const url = API_URL.SYSTEM_USERS.CREATE;

  try {
    let result = await dataUploadApi(url, payload);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchUserRolesDropdown = async (companyId = null) => {
  const url = companyId 
    ? `${API_URL.SYSTEM_USERS.ROLESDROPDOWN}?companyId=${companyId}`
    : API_URL.SYSTEM_USERS.ROLESDROPDOWN;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchAllLocations = async (companyId = null) => {
  const url = companyId
    ? `${API_URL.SYSTEM_USERS.GET_LOCATIONS}?companyId=${companyId}`
    : API_URL.SYSTEM_USERS.GET_LOCATIONS;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result || [];
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const flattenCompanies = (companies = []) => {
  const flat = [];
  companies.forEach((company) => {
    flat.push({
      companyId: company.companyId,
      companyName: company.companyName,
      companyCode: company.companyCode,
    });
    if (Array.isArray(company.childCompanies) && company.childCompanies.length > 0) {
      company.childCompanies.forEach((child) => {
        flat.push({
          companyId: child.companyId,
          companyName: `${child.companyName}`,
          companyCode: child.companyCode,
        });
      });
    }
  });
  return flat;
};

export const fetchAllCompanies = async () => {
  const url = API_URL.SYSTEM_USERS.GET_COMPANIES;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result || [];
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

